import React from "react";
import { Helmet } from "react-helmet";

import Header from "./components/Header";
import Footer from "./components/Footer";

import "./css/homestyle.css";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Krisula GlobExim</title>

        <meta charSet="UTF-8" />

        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        />

        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css"
        />
      </Helmet>

      {/* HEADER (DYNAMIC COMPONENT) */}
      <Header />

      {/* HERO SECTION */}
      <section className="hero">
        <div className="overlay"></div>

        <div className="hero-content">
          <h1>Exports & Imports of Agro Products</h1>

          <p>
            Trusted Exporter & Importer of Fresh Fruits, Vegetables,
            Rice & Wheat
          </p>

          <a href="/products" className="hero-btn">
            Explore Products
          </a>
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section className="about-section">
        <div className="container about-grid">
          <div className="about-image">
            <img
              src="https://static.vecteezy.com/system/resources/thumbnails/046/009/765/small_2x/burlap-sack-of-rice-and-grains-on-the-right-photo.jpeg"
              alt="Agriculture"
            />
          </div>

          <div className="about-content">
            <span className="section-tag">About Us</span>

            <h2>M/s. Krisula GlobExim Pvt Ltd.</h2>

            <p>
              Krisula GlobExim Pvt. Ltd. is a trustworthy Exporter,
              Importer, Dealer, Trader, Wholesaler, Distributor and
              Supplier of Agricultural Products.
            </p>

            <p>
              We deal with Fresh Fruits, Fresh Vegetables, Rice and Wheat
              domestically and internationally.
            </p>

            <a href="/about" className="secondary-btn">
              Read More
            </a>
          </div>
        </div>
      </section>

      {/* PRODUCTS */}
      <section className="products">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Our Products</span>

            <h2>Major Export Products</h2>
          </div>

          <div className="product-grid">
            <div className="product-card">
              <img
                src="https://evergreen.ie/cdn/shop/products/masma_1.jpg?v=1624525385&width=3840"
                alt="Basmati"
              />

              <div className="product-content">
                <h3>Basmati Rice</h3>
                <p> Our Basmati Rice ranges are Traditional Basmati, Pusa Basmati,
            1121 Basmati & Sugandha Basmati.</p>
              </div>
            </div>
             <div className="product-card">
              <img
                src="https://img.republicworld.com/all_images/india-non-basmati-rice-export-namibia-1722262929954-16_9.webp?w=1280&h=720&q=75&format=webp"
                alt="Non-Basmati"
              />

              <div className="product-content">
                <h3>Non-Basmati Rice</h3>
                <p> Our Non-Basmati Rice, In Long Grain ranges are PR11, IR 36, IR 64 & Parimal.</p>
              </div>
            </div>

 <div className="product-card">
              <img
                src="https://5.imimg.com/data5/SELLER/Default/2021/5/ER/UP/JS/51399859/wheat-flour-1000x1000.jpg"
                alt="weat flour"
              />

              <div className="product-content">
                <h3>Wheat (GRAIN/FLOUR)</h3>
                <p>We supply & export best quality of Wheat (Grain/Flour)
            from India.</p>
              </div>
            </div>


            <div className="product-card">
              <img
                src="https://shop.panchayatudsar.com/wp-content/uploads/2022/07/Organic-Bajra-Flour.jpg"
                alt="BAJARA"
              />

              <div className="product-content">
                <h3>BAJARA (GREEN MILET) / YELLOW MAIZE</h3>
                <p> We Supply best quality of Bajara (Green Milet)
            & Yellow maize for human consumption and
            animal/cattle feed.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section className="contact-section">
        <div className="container contact-grid">
          <div>
            <h2>Contact Us</h2>

            <p>
              210, 2nd Floor, Mahalaxmi Market, Pune, Maharashtra, India.
            </p>

            <p>+91-7507002346</p>
            <p>info@krisulaglobexim.com</p>
          </div>

          <form className="contact-form">
            <input type="text" placeholder="Your Name" />
            <input type="email" placeholder="Email" />

            <textarea rows="5" placeholder="Message"></textarea>

            <button type="submit">Submit</button>
          </form>
        </div>
      </section>

      {/* FOOTER (DYNAMIC COMPONENT) */}
      <Footer />
    </>
  );
};

export default Home;